import { defineEvents, event, type PropsOf } from '@mathflat/data-tracking'

import type { EventPropertiesSchema } from './eventProperties.schema'

// 화면 코드가 track() 으로 부르는 이벤트. 응답 인터셉터가 보내는 API 이벤트는 apiEvent.schema.ts 에 있다

// eventCode 접두 이벤트. 이름은 Mixpanel 대시보드에 걸려 있어 그대로 두고, 새 이벤트는 newEvents 끝에 추가한다
const legacyEvents = defineEvents({
  // PROD 12개월(2025-10-27 ~ 2026-10-26) 수신 0건이고 호출부도 없어 안 쓰는 것으로 추정
  // 'T11-01_배송지_수정하기btn': event(),
  // 'T11-02_배송지_수정완료하기btn': event(),
  // 'T32-16_시그니처교재_다운로드': event(),
  // 'T70-08_경시대회_홍보이미지다운로드': event(),
  // 'T31-01_생성완료학습지_시그니처교재': event<EventPropertiesSchema.생성완료학습지_시그니처교재>(),
  // 'T56-03_VOD아티클상세_동영상실행': event(),
  // 'T32-21_시그니처교재_정식가입_정식가입하기선택': event(),
  // 'T32-22_시그니처교재_구매한교재만보기': event<EventPropertiesSchema.토글전환값>(),
  // 'T32-24_시그니처교재_주문배송조회선택': event(),
  // 'T32-20_시그니처교재만들기_Step2_저장btn':
  // event<EventPropertiesSchema.시그니처교재표지편집저장>(),
  // 'T32-20_시그니처교재만들기_Step2_이전btn': event<EventPropertiesSchema.편집중교재>(),
  // 'T32-01_내교재목록_교재만들기btn': event(),
  // 'T36-01_교재만들기1단계_다음단계btn': event(),
  // 'T36-02_교재만들기2단계_이전btn': event<EventPropertiesSchema.생성수정타입>(),
  // 'T36-02_교재만들기2단계_다음단계btn': event<EventPropertiesSchema.생성수정타입>(),
  // 'T36-09_교재만들기3단계_이전단계btn': event<EventPropertiesSchema.생성수정타입>(),
  // 'T61-01_내신관_학교별기출학습하기_단원별학습지': event(),
  // 'T61-01_내신관_학교별기출학습하기_AI기출업로드': event(),
  // 'T61-01_내신관_학교별기출학습하기_학교내신기출유사문제': event(),
  // 'T61-03_내신관_학생별취약유형잡아주기_유형분석': event(),
  // 'T61-03_내신관_학생별취약유형잡아주기_시그니처교재': event(),
  // 'T61-04_내신관_학교별기출교재_바로체험해보기': event(),

  'T10-01_무료체험신청_말풍선_이동클릭': event<EventPropertiesSchema.QueryString>(),
  'T10-01_무료체험신청_말풍선_X클릭': event(),
  'T10-01_로그인화면_수동': event<EventPropertiesSchema.QueryString>(),
  'T12-01_콘텐츠업데이트PV': event(),
  'T12-02_콘텐츠업데이트스크롤': event<EventPropertiesSchema.스크롤높이>(),
  'T23-01_내정보_교재구매상세_장바구니담기btn':
    event<EventPropertiesSchema.교재구매상세_교재정보>(),
  'T23-01_내정보_교재구매상세_재주문하기btn': event<EventPropertiesSchema.재주문항목>(),
  'T23-02_내정보_교재구매내역상세_송장번호btn': event(),
  '개념강의_선생님앱_시청기록_UI_T30-01': event(),
  'T30-01_개념강의_선생님앱_강의_선택': event<EventPropertiesSchema.개념강의_선택>(),
  'T30-01_개념강의_선생님앱_공개설정': event<EventPropertiesSchema.토글>(),
  'T30-01_개념강의_선생님앱_링크공유': event<EventPropertiesSchema.개념강의정보>(),
  'T30-01_개념강의_선생님앱_링크복사': event<EventPropertiesSchema.개념강의정보>(),
  'T32-15_시그니처교재_편집주문하러가기': event<EventPropertiesSchema.시그니처교재_편집주문>(),
  'T32-24_교재장바구니_교재삭제btn': event<EventPropertiesSchema.장바구니_교재정보>(),
  'T32-24_교재장바구니_시그니처교재_둘러보기': event(),
  'T32-24_교재장바구니_내교재_둘러보기': event(),
  'T32-24_교재장바구니_결제하기': event<EventPropertiesSchema.쿠폰보유여부>(),
  'T32-24_교재장바구니_PV': event<EventPropertiesSchema.쿠폰보유여부>(),
  'T32-26_교재주문/결제_PV': event<EventPropertiesSchema.쿠폰보유여부>(),
  'T32-26_교재주문/결제_결제하기btn_n': event<EventPropertiesSchema.쿠폰적용결제>(),
  'T32-26_교재주문/결제_쿠폰박스btn': event(),
  'T32-26_교재주문/결제_쿠폰사용하기btn': event<EventPropertiesSchema.쿠폰정보>(),
  'T32-26_교재주문/결제_쿠폰검색btn': event(),
  'T32-26_교재주문/결제_쿠폰검색결과': event<EventPropertiesSchema.검색결과유무>(),
  'T32-26_교재주문/결제_쿠폰추가하기btn': event<EventPropertiesSchema.쿠폰정보>(),
  'T32-27_시그니처교재_학부모가결제탭_클릭': event(),
  'T32-28_시그니처교재_학부모가결제탭_담기클릭': event(),
  'T32-29_시그니처교재_학부모가결제_구매요청클릭': event(),
  'T32-30_시그니처교재_학부모가결제_모달내_보내기클릭': event(),
  'T32-31_시그니처교재_가격토글클릭': event<EventPropertiesSchema.가격표시토글>(),
  'T32-32_내교재_학부모가결제탭_클릭': event(),
  'T32-33_내교재_학부모가결제탭_담기클릭': event(),
  'T32-34_내교재_학부모가결제_구매요청클릭': event(),
  'T32-35_내교재_학부모가결제_모달내_보내기클릭': event(),
  'T32-36_내교재_가격토글클릭': event<EventPropertiesSchema.가격표시토글>(),
  'T32-37_장바구니_학부모가결제탭_PV': event(),
  'T32-38_장바구니_학부모가결제탭내_구매요청클릭': event(),
  'T32-39_장바구니_학부모가결제_모달내_보내기클릭': event(),
  'T32-40_학부모결제완료후팝업내_정산정보입력버튼클릭': event(),
  'T32-41_주문내역_학부모구매_PV': event(),
  'T32-42_주문내역_학부모구매_주문상세_버튼클릭': event(),
  'T32-43_주문내역_학부모주문상세의주문취소_클릭': event(),
  'T32-44_주문내역_학부모주문상세의재발송_클릭': event(),
  'T32-45_주문내역_학부모주문상세의직접결제_클릭': event(),
  'T32-46_주문내역_학부모주문상세의장바구니담기_클릭': event(),
  'T32-47_시그니처교재_학부모가결제_모달내_가이드영상클릭': event(),
  'T32-48_시그니처교재_100%기능이해하기클릭': event(),
  'T32-49_시그니처교재_100%기능이해하기_학부모결제클릭': event(),
  'T32-50_시그니처교재_학부모가결제탭_스피치버블_자세히보기클릭': event(),
  'T32-51_내교재_학부모가결제_모달내_가이드영상클릭': event(),
  'T32-52_내교재_학부모가결제탭_스피치버블_자세히보기클릭': event(),
  'T32-53_학부모결제페이지_결제하기_클릭': event(),
  'T32-54_학부모결제페이지_결제완료페이지_PV': event(),
  'T35-03_시중교재_예시문항보기_토글': event<EventPropertiesSchema.ONOFF토글>(),
  'T43-01_시그니처_수업보기모드': event(),
  'T42-18_[학습지]_문풀동_안내배너_컨설팅_유도_click': event(),
  'T43-09_[교재]_문풀동_안내배너_컨설팅_유도_click': event(),
  'T46-01_유형분석_개별학생_PV': event<EventPropertiesSchema.유형분석_개별학생진입>(),
  'T46-01_유형분석_필터_추천유형토글_API': event<EventPropertiesSchema.유형분석필터_추천유형토글>(),
  'T46-01_유형분석_필터_과거학습이력_API': event<EventPropertiesSchema.유형분석필터_과거학습이력>(),
  'T46-01_유형분석_필터_등급별 선택_API': event<EventPropertiesSchema.유형분석필터_등급>(),
  'T46-01_유형분석_필터_중단원 선택_API': event<EventPropertiesSchema.유형분석필터_단원선택>(),
  'T46-01_유형분석_필터_소단원 선택_API': event<EventPropertiesSchema.유형분석필터_단원선택>(),
  'T46-01_유형분석_필터_난이도 선택_API': event<EventPropertiesSchema.유형분석필터_난이도>(),
  'T46-01_유형분석_필터_중단원 아코디언_API':
    event<EventPropertiesSchema.유형분석필터_중단원아코디언>(),
  'T46-01_유형분석_필터_시그니처교재_API': event<EventPropertiesSchema.유형분석필터_시그니처교재>(),
  'T46-01_유형분석_필터_시중교재_API': event<EventPropertiesSchema.유형분석필터_시중교재>(),
  'T46-01_유형분석_필터_교과서_API': event<EventPropertiesSchema.유형분석필터_교과서>(),
  'T46-02_유형분석_상세정보_API': event<EventPropertiesSchema.유형분석_상세정보>(),
  'T46-02_유형분석_상세정보_정답/해설_API': event<EventPropertiesSchema.학기과목>(),
  'T46-03_유형분석_출제모달_유형별학습지_API':
    event<EventPropertiesSchema.유형분석_출제모달_유형별학습지>(),
  'T46-03_유형분석_출제모달_유형별오답학습지_API':
    event<EventPropertiesSchema.유형분석_출제모달_유형별오답학습지>(),
  'T46-01_유형분석_필터_학교별기출': event(),
  'T46-01_생성완료_유형분석_보고서': event<EventPropertiesSchema.유형분석보고서생성>(),
  'T46-01_유형분석_보고서_AI코멘트': event<EventPropertiesSchema.생성완료여부>(),
  'T46-01_유형분석_보고서_미리보기': event(),
  'T46-01_유형분석_보고서_문자발송': event(),
  'T46-01_유형분석_보고서_링크복사': event(),
  'T46-01_유형분석_보고서_올림앱공유': event(),
  // 아래 4개와 T70-10 은 LNB 코드를 지운 뒤에도 최신 배포에서 수신된다. Framer 경시대회 페이지가 링크로 보내는 것으로
  // 추정되니 지우기 전에 Framer 에서 쓰는지 확인한다
  'T70-02_경시대회_LNB_대회소개_클릭': event(),
  'T70-03_경시대회_LNB_시행안내_클릭': event(),
  'T70-04_경시대회_LNB_응시하기_클릭': event(),
  'T70-05_경시대회_LNB_상장배너신청_클릭': event(),
  'T70-06_경시대회_샘플시험지다운로드': event(),
  'T70-07_경시대회_샘플보고서다운로드': event(),
  'T70-09_경시대회_출제하기': event(),
  // Framer 경시대회 페이지가 보내는 것으로 추정 — 지우기 전에 확인한다 (위 T70-02 주석 참고)
  'T70-10_경시대회_상장배너결제하기': event(),
  'T71-01_가상학생등록완료': event<EventPropertiesSchema.가상학생등록완료>(),
  'T71-02_가상학생등록실패': event(),
  'T42-12_일괄채점_일괄오답학습지_학생별': event<EventPropertiesSchema.일괄오답학습지출제>(),
  'T99-03_정복_프로필_클릭': event<EventPropertiesSchema.열기닫기동작>(),
  'T99-03_정복_기능카드_클릭': event<EventPropertiesSchema.시나리오_기능카드>(),
  'T99-03_정복_기능카드_네비게이션클릭': event<EventPropertiesSchema.네비게이션방향>(),
  'T99-03_정복_설명팝업_CTA버튼': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_설명팝업_노출': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_설명팝업_포인터타겟클릭': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_설명팝업_동영상링크': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_완료팝업_닫기': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_완료팝업_다음버튼': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_완료팝업_노출': event<EventPropertiesSchema.메인시나리오>(),
  'T99-03_정복_좋아요카드_좋아요': event<EventPropertiesSchema.서브시나리오>(),
  'T99-03_정복_좋아요카드_좋아요취소': event<EventPropertiesSchema.서브시나리오>(),
  'T99-04_정식가입하러가기툴팁_신청하기클릭': event(),
  'T99-04_정식가입하러가기툴팁_닫기': event(),
  'T99-04_정식가입하러가기_내정보_신청하기클릭': event(),
  'T31-01_생성완료학습지_단원유형별': event<EventPropertiesSchema.생성완료학습지_단원유형별>(),
  'T31-01_생성완료학습지_시중교재': event<EventPropertiesSchema.생성완료학습지_시중교재>(),
  'T31-01_생성완료학습지_수능모의고사': event<EventPropertiesSchema.생성완료학습지_수능모의고사>(),
  'T31-01_생성완료학습지_기출업로드': event<EventPropertiesSchema.생성완료학습지_기출업로드>(),
  'T42-05_생성완료학습지_원클릭복습': event<EventPropertiesSchema.생성완료학습지_원클릭복습>(),
  'T31-10_학생지공개상태모달': event<EventPropertiesSchema.공개상태>(),
  'T33-00_테마별학습지_출제하기': event<EventPropertiesSchema.테마별학습지_출제>(),
  'T33-00_테마별학습지_일괄출제': event<EventPropertiesSchema.학습지수>(),
  'T33-00_테마별학습지_다운로드': event<EventPropertiesSchema.학습지수>(),
  'T33-00_테마별학습지_인쇄': event<EventPropertiesSchema.학습지수>(),
  'T56-01_VOD아티클목록조회': event(),
  'T56-02_VOD아티클상세조회': event(),
  'T56-04_VOD아티클상세_PDF다운받기': event(),
  'T56-05_VOD아티클상세_질문의견남기기': event(),
  'T56-06_VOD아티클상세_정식가입하기(무료체험자)': event(),
  'T32-18_시그니처교재_1단원PDF다운로드/내보내기_선택':
    event<EventPropertiesSchema.시그니처교재_PDF다운로드>(),
  'T32-18_시그니처교재_문제지_PDF다운로드선택':
    event<EventPropertiesSchema.시그니처교재_PDF다운로드>(),
  'T32-19_시그니처교재_정답해설PDF다운로드/내보내기_선택':
    event<EventPropertiesSchema.시그니처교재_PDF다운로드>(),
  'T32-17_시그니처교재_출제하기': event<EventPropertiesSchema.시그니처교재_출제>(),
  'T32-20_시그니처교재_체험교재가이드선택': event(),
  'T32-21_내교재_정식가입_정식가입하기선택': event(),
  'T32-21_장바구니_정식가입_정식가입하기선택': event(),
  'T32-21_커스텀프린트_정식가입_정식가입하기선택': event(),
  'T32-23_시그니처교재_교재주문하기선택': event(),
  'T41-02_학습내역_해설버튼': event<EventPropertiesSchema.필기유무_전환>(),
  'T41-02_학습내역_필기미리보기': event(),
  'T42-06_개인학습지채점_해설버튼': event<EventPropertiesSchema.필기유무>(),
  'T42-06_개인학습지채점_필기미리보기': event(),
  'T46-02_유형분석상세_해설버튼': event<EventPropertiesSchema.유형분석상세_해설>(),
  'T46-02_유형분석상세정보_필기미리보기': event<EventPropertiesSchema.유형분석상세_채점문항>(),
  T42_01_학습지_현황_PV: event<EventPropertiesSchema.학습지현황_PV>(),
  T42_01_학습지_현황_그룹채점이동: event<EventPropertiesSchema.현황_공통>(),
  T42_01_학습지_현황_개인채점이동: event<EventPropertiesSchema.현황_공통>(),
  T42_01_학습지_현황_출제변경: event<EventPropertiesSchema.현황_공통>(),
  T42_01_학습지_현황_엑셀다운로드: event<EventPropertiesSchema.현황_엑셀다운로드>(),
  T03_01_교재_현황_PV: event<EventPropertiesSchema.교재현황_PV>(),
  T03_01_교재_현황_그룹채점이동: event<EventPropertiesSchema.현황_공통>(),
  T03_01_교재_현황_개인채점이동: event<EventPropertiesSchema.현황_공통>(),
  T41_03_학습통계_PV: event<EventPropertiesSchema.현황_공통>(),
  T41_03_학습통계_엑셀다운로드: event<EventPropertiesSchema.현황_엑셀다운로드>(),
  'T35-13_학교별기출학습지_학습지만들기': event<EventPropertiesSchema.학교별기출_학습지만들기>(),
  'T35-13_학교별기출학습지_지역학교선택': event<EventPropertiesSchema.학교별기출_지역학교선택>(),
  'T35-13_학교별기출학습지_학교명검색': event<EventPropertiesSchema.학교별기출_학교명검색결과>(),
  'T32-13_시그니처교재_복제후수정btn': event<EventPropertiesSchema.커스텀시그니처교재정보>(),
  'T32-13_시그니처교재_수정btn': event<EventPropertiesSchema.커스텀시그니처교재정보>(),
  'T32-13_시그니처교재_삭제btn': event<EventPropertiesSchema.커스텀시그니처교재정보>(),
  'T32-13_시그니처교재_구매하기btn': event<EventPropertiesSchema.커스텀시그니처교재정보>(),
  'T32-23_시그니처교재상세보기_PV': event<EventPropertiesSchema.시그니처교재상세정보>(),
  'T32-23_시그니처교재상세보기_표지편집btn': event<EventPropertiesSchema.시그니처교재상세정보>(),
  'T32-20_시그니처교재만들기_Step2_저장완료btn':
    event<EventPropertiesSchema.시그니처교재표지편집저장>(),
  'T57-01_실험실_AI튜터': event<EventPropertiesSchema.사용설정>(),
  'T57-02_실험실_유형분석보고서': event<EventPropertiesSchema.사용설정>(),
  'T57-02_실험실_원클릭복습': event<EventPropertiesSchema.사용설정>(),
  'T99-01_매쓰플랫알림판': event<EventPropertiesSchema.알림판>(),
  'T99-01_매쓰플랫알림판_일반닫기': event(),
  'T99-01_매쓰플랫알림판_3일동안닫기': event(),
  'T99-01_매쓰플랫알림판_링크버튼_Click': event<EventPropertiesSchema.알림판>(),
  'T32-01_내교재목록_구매하기btn': event<EventPropertiesSchema.내교재목록_구매>(),
  'T32-01_내교재목록_담기btn': event<EventPropertiesSchema.내교재목록_주문>(),
  'T32-01_내교재목록_주문하기btn': event<EventPropertiesSchema.내교재목록_주문>(),
  'T32-01_내교재목록_토스트_장바구니바로가기btn': event(),
  'T36-01_교재만들기1단계_닫기btn': event(),
  'T36-02_교재만들기2단계_닫기btn': event<EventPropertiesSchema.생성수정타입>(),
  'T36-09_교재만들기3단계_닫기btn': event<EventPropertiesSchema.생성수정타입>(),
  'T31-01_마이리스트_목록': event<EventPropertiesSchema.마이리스트_목록>(),
  'T31-01_마이리스트_생성완료': event<EventPropertiesSchema.마이리스트_생성>(),
  'T31-01_마이리스트_만들기_btn_Click': event(),
  '[수업] 학습지채점_문풀동_모달': event<EventPropertiesSchema.학습지문풀동>(),
  '[수업] 교재채점_문풀동_모달': event<EventPropertiesSchema.교재문풀동>(),
  '[수업] 학습지채점_문풀동_재생': event<EventPropertiesSchema.학습지문풀동>(),
  '[수업] 내교재채점_문풀동_재생': event<EventPropertiesSchema.교재문풀동>(),
  '[수업] 시그니처교재채점_문풀동_재생': event<EventPropertiesSchema.시그니처교재문풀동>(),
  '[수업] 문제은행_문풀동_넛지배너_Click': event<EventPropertiesSchema.문풀동넛지배너>(),
  '[수업] 시그니처_문풀동_넛지배너_Click': event<EventPropertiesSchema.문풀동넛지배너>(),
  '[스쿨] [학생관리] 학생이용권_학생목록': event<EventPropertiesSchema.학생이용권_목록>(),
  '[스쿨] [학생관리] 학생이용권_활성화': event<EventPropertiesSchema.학생이용권_활성화>(),
  '[스쿨] [학생관리] 학생이용권_비활성화': event<EventPropertiesSchema.학생이용권_비활성화>(),
  '[스쿨] [학생관리] 학생이용권_상담신청': event<EventPropertiesSchema.학생이용권_상담신청>(),
  '[수업] 실시간모니터링_진입': event<EventPropertiesSchema.실시간모니터링_진입>(),
  '[수업] 실시간모니터링_전체뷰_PV': event<EventPropertiesSchema.실시간모니터링_학습지>(),
  '[수업] 실시간모니터링_개별뷰_PV': event<EventPropertiesSchema.실시간모니터링_학습지>(),
  '[수업] 실시간모니터링_문제선택': event<EventPropertiesSchema.실시간모니터링_문제선택>(),
  '[수업] 실시간모니터링_선생님필기': event<EventPropertiesSchema.실시간모니터링_선생님필기>(),
  '[수업] 실시간모니터링_학습지교체': event<EventPropertiesSchema.실시간모니터링_학습지>(),
  'T61-01_내신관_학교별기출학습하기_학교내신기출시험지': event(),
  'T61-01_내신관_학교별기출학습하기_인근지역의내신기출시험지': event(),
  'T61-02_내신관_출판사별교과서대비하기_교과서빈출기반학습지': event(),
  'T61-02_내신관_출판사별교과서대비하기_교과서별내신대비문제': event(),
  '[대시보드] 퀵메뉴_선택': event<EventPropertiesSchema.대시보드_퀵메뉴>(),
  '[대시보드] 학습지 목록_학습지 선택': event<EventPropertiesSchema.대시보드_학습지선택>(),
  '[대시보드] 학습지 성취 분포_코호트 선택': event<EventPropertiesSchema.코호트>(),
  '[대시보드] 생성완료_학습지일괄오답관리': event<EventPropertiesSchema.코호트선택>(),
  '[대시보드] 많이틀린문제_문제보기': event<EventPropertiesSchema.대시보드_많이틀린문제>(),
  '[대시보드] 많이틀린문제_학생보기': event<EventPropertiesSchema.대시보드_많이틀린문제>(),
  '[대시보드] 대시보드_PV': event<EventPropertiesSchema.대시보드_PV>(),
  '[대시보드] 매트릭스_학습유형 선택': event<EventPropertiesSchema.대시보드_매트릭스>(),
  '[대시보드] 그룹유형분석_교재_필터':
    event<EventPropertiesSchema.대시보드_그룹유형분석_교재필터>(),
  '[대시보드] 그룹유형분석_성취도컬러_필터': event<EventPropertiesSchema.성취도컬러>(),
  '[대시보드] 스크롤': event<EventPropertiesSchema.대시보드_스크롤영역>(),
  'T11-01_gnb_커스텀프린팅btn': event(),
  'T62-01_커스텀프린팅Step1_닫기모달확인btn': event(),
  'T62-01_커스텀프린팅Step1_파일업로드btn': event(),
  'T62-01_커스텀프린팅Step1_드래그앤드롭': event(),
  'T62-02_커스텀프린팅Step2_파일업로드': event(),
  'T62-02_커스텀프린팅Step2_닫기모달확인btn': event(),
  'T62-02_커스텀프린팅Step2_다음단계btn': event(),
  'T62-02_커스텀프린팅Step2_결제하기모달주문하기btn': event(),
  'T62-02_커스텀프린팅Step2_다른파일업로드btn': event(),
  'T62-02_커스텀프린팅Step2_드래그앤드롭': event(),
  'T62-03_커스텀프린팅_진입점_교재띠배너': event(),
  'T62-03_커스텀프린팅_진입점_학습지다운로드배너': event(),
  'T62-03_커스텀프린팅_진입점_학습지인쇄배너': event(),
  'T62-03_커스텀프린팅_진입점_교재다운로드배너': event(),
  'T62-03_커스텀프린팅_진입점_교재인쇄배너': event(),
  '[대시보드] 리스트_개별유형분석_바로가기': event<EventPropertiesSchema.대시보드_개별유형분석>(),
  '[내학습지] 휴지통_PV': event(),
  '[내학습지] 휴지통_복구': event<EventPropertiesSchema.복구개수>(),

  'T33-43_연산_학습지조회_API': event<EventPropertiesSchema.연산필터>(),
  'T33-43_연산_학습지인쇄/다운로드_API': event<EventPropertiesSchema.연산학습지인쇄다운로드>(),
  'T33-43_연산_초등1~2_문제보기_API': event(),
  'T33-43_연산_초등1~2_정답보기_API': event(),
  'T33-43_연산_초등3~6_문제보기_API': event<EventPropertiesSchema.연산학습지>(),
  'T33-43_연산_초등3~6_정답보기_API': event<EventPropertiesSchema.연산학습지>(),
  'T33-43_연산_중고등_미리보기_API': event<EventPropertiesSchema.연산중고등학습지>(),
  'T33-43_연산_중고등_수정_API': event<EventPropertiesSchema.연산중고등학습지>(),
  'T33-43_연산_중고등_출제_API': event<EventPropertiesSchema.연산중고등학습지출제>(),
  'T33-43_연산_미리보기좌_API': event(),
  'T33-43_연산_미리보기우_API': event(),
  'T43-05_교재문제채점_API': event<EventPropertiesSchema.교재출제학생>(),
})

const newEvents = defineEvents({
  // PROD 12개월(2025-10-27 ~ 2026-10-26) 수신 0건이고 호출부도 없어 안 쓰는 것으로 추정
  // 내교재만들기_3단계_교재정보탭_교재만들기버튼_Click: event<EventPropertiesSchema.내교재만들기_교재만들기버튼>(),
  // 페이지성능측정: event<EventPropertiesSchema.페이지성능측정>(),
  로그인_업데이트안내_Click: event(),
  내교재목록_복제후수정버튼_Click: event<EventPropertiesSchema.교재목록_내교재>(),
  내교재목록_수정버튼_Click: event<EventPropertiesSchema.교재목록_내교재>(),
  내교재만들기버튼_Click: event(),
  내교재만들기_1단계_다음단계버튼_Click: event<EventPropertiesSchema.내교재만들기_단계이동>(),
  내교재만들기_2단계_다음단계버튼_Click: event<EventPropertiesSchema.내교재만들기_2단계_단계이동>(),
  내교재만들기_3단계_완료모달_취소버튼_Click: event<EventPropertiesSchema.내교재만들기_완료모달>(),
  내교재만들기_3단계_완료모달_확인버튼_Click:
    event<EventPropertiesSchema.내교재만들기_완료모달_확인>(),
  내교재만들기_3단계_내지선택탭_이전단계_Click:
    event<EventPropertiesSchema.내교재만들기_3단계_탭이동>(),
  내교재만들기_3단계_내지선택탭_다음단계_Click:
    event<EventPropertiesSchema.내교재만들기_3단계_탭이동>(),
  내교재만들기_3단계_내지선택탭_Click: event<EventPropertiesSchema.내교재만들기_3단계_탭이동>(),
  내교재만들기_3단계_교재정보탭_이전단계_Click:
    event<EventPropertiesSchema.내교재만들기_3단계_탭이동>(),
  내교재만들기_3단계_교재정보탭_Click: event<EventPropertiesSchema.내교재만들기_3단계_탭>(),
  내교재만들기_3단계_표지선택탭_Click: event<EventPropertiesSchema.내교재만들기_3단계_탭>(),
  내교재만들기_3단계_표지선택탭_이전단계_Click:
    event<EventPropertiesSchema.내교재만들기_3단계_탭>(),
  내교재만들기_3단계_표지선택탭_다음단계_Click:
    event<EventPropertiesSchema.내교재만들기_3단계_탭이동>(),
  교재만들기_3단계_줄여서보기_Click: event(),
  교재만들기_3단계_늘여서보기_Click: event(),
  교재만들기_2단계_줄여서보기_Click: event(),
  교재만들기_2단계_늘여서보기_Click: event(),
  교재만들기_1단계_줄여서보기_Click: event(),
  교재만들기_1단계_늘여서보기_Click: event(),
  학습지만들기_3단계_줄여서보기_Click: event(),
  학습지만들기_3단계_늘여서보기_Click: event(),
  학습지만들기_2단계_줄여서보기_Click: event(),
  학습지만들기_2단계_늘여서보기_Click: event(),
  학습지만들기_1단계_줄여서보기_Click: event(),
  학습지만들기_1단계_늘여서보기_Click: event(),
  수능경시관_미리보기_Click: event<EventPropertiesSchema.수능경시관_공통>(),
  수능경시관_출제하기_Click: event<EventPropertiesSchema.수능경시관_공통>(),
  수능경시관_다운로드_Click: event<EventPropertiesSchema.수능경시관_공통>(),
  수능경시관_인쇄하기_Click: event<EventPropertiesSchema.수능경시관_공통>(),
  시중교재전체지원_진입점_알림: event(),
  시중교재전체지원_진입점_띠배너: event(),
  서술형_진입점_알림: event(),
  '시그니처교재리스트_첫번째교재(홍보구좌)_Click': event(),
  학습지만들기_Click: event(),
  학습지만들기_연산탭_Click: event(),
  내교재만들기_시중교재_선택: event<EventPropertiesSchema.시중교재_선택>(),
  학습지만들기_시중교재_선택: event<EventPropertiesSchema.시중교재_선택>(),

  학습지만들기_3단계_학습지만들기_최종: event<EventPropertiesSchema.학습지_최종>(),
  학습지만들기_1단계_다음버튼: event<EventPropertiesSchema.학습지만들기_1단계_다음버튼>(),
  학습지만들기_2단계_다음버튼: event<EventPropertiesSchema.학습지만들기_2단계_다음버튼>(),
  학습지만들기_2단계_이전버튼: event<EventPropertiesSchema.학습지만들기_단계이동버튼>(),
  학습지만들기_2단계_닫기버튼: event<EventPropertiesSchema.학습지만들기_단계이동버튼>(),
  학습지만들기_3단계_이전버튼: event<EventPropertiesSchema.학습지만들기_단계이동버튼>(),
  학습지만들기_3단계_닫기버튼: event<EventPropertiesSchema.학습지만들기_단계이동버튼>(),

  학습지_다운로드모달_다운로드_Click: event<EventPropertiesSchema.내학습지_선택학습지_다운로드>(),

  교재_문제오류신고: event<EventPropertiesSchema.교재_문제오류신고>(),
  학습지_문제오류신고: event<EventPropertiesSchema.학습지_문제오류신고>(),

  문제별오답학습지생성: event<EventPropertiesSchema.문제별오답학습지생성>(),
  페이지별오답학습지생성: event<EventPropertiesSchema.페이지별오답학습지생성>(),
  교재_시중교재_출제완료: event<EventPropertiesSchema.시중교재지원분류>(),
  샘플홍보물보고서보러가기_Click: event(),
  // 아래 5개는 Framer 내신관 페이지가 링크(eventName 쿼리)로 보내 코드에 호출부가 없다. 지우기 전에 Framer 에서 쓰는지 확인한다
  내신관_후기_Click: event<EventPropertiesSchema.내신관_후기>(),
  내신관_데이터_개별데이터_Click: event<EventPropertiesSchema.내신관_데이터_개별데이터>(),
  내신관_데이터_내신교재판매비율_Click:
    event<EventPropertiesSchema.내신관_데이터_내신교재판매비율>(),
  내신관_데이터_기능사용률_Click: event<EventPropertiesSchema.내신관_데이터_기능사용률>(),
  내신관_상단기능_Click: event<EventPropertiesSchema.내신관_기능모음>(),
  내신관스크롤: event<EventPropertiesSchema.ScrollDepth>(),
  콘텐츠업데이트스크롤: event<EventPropertiesSchema.ScrollDepth>(),
  학원로고_Click: event(),
  학습지만들기_학교별기출_학교선택: event<EventPropertiesSchema.기출지원분류>(),
  교재만들기_학교별기출_학교선택: event<EventPropertiesSchema.기출지원분류>(),
  교재만들기_학교별기출_기출업로드: event<EventPropertiesSchema.기출지원분류>(),
  교재만들기_학교별기출_기출업로드_완료: event<EventPropertiesSchema.기출지원분류>(),
  기출업로드_파일첨부: event(),
  기출업로드_파일첨부완료: event<EventPropertiesSchema.기출파일첨부>(),
  기출업로드_1단계정보수정: event<EventPropertiesSchema.기출업로드시험정보수정>(),
  기출업로드_1단계최종버튼: event<EventPropertiesSchema.기출업로드시험정보>(),
  기출업로드_로딩모달: event(),
  매쓰플랫로그인페이지_시작하기버튼_Click: event(),
  매쓰플랫로그인페이지_로그인아이디안내_Click: event(),
  매쓰플랫로그인페이지_비밀번호찾기_Click: event(),
  매쓰플랫로그인페이지_툴팁링크_Click: event(),
  로그인페이지_프로모션영역_버튼_Click: event(),
  학습지_병합파퍼_Click: event(),
  학습지_병합완료모달_Click: event<EventPropertiesSchema.학습지병합종류>(),
  학습지_병합실패: event<EventPropertiesSchema.학습지병합실패사유>(),
  내신대비_미리보기: event<EventPropertiesSchema.내신대비_공통>(),
  내신대비_인쇄하기: event<EventPropertiesSchema.내신대비_공통>(),
  내신대비_다운로드: event<EventPropertiesSchema.내신대비_공통>(),
  내신대비_출제하기: event<EventPropertiesSchema.내신대비_공통>(),
  서술형_미리보기: event(),
  서술형_인쇄하기: event(),
  서술형_다운로드: event(),
  /** 프로퍼티는 개별 출제에만 있다 — 일괄 출제는 학습지 단위 값을 특정할 수 없어 붙이지 않는다 */
  서술형_출제하기: event<EventPropertiesSchema.서술형출제 | undefined>(),
  교재표지편집_표지리스트늘려보기버튼_Click: event<EventPropertiesSchema.표지리스트보기방법>(),
  교재표지편집_최근선택한표지버튼_Click: event(),
  교재표지편집_즐겨찾는표지버튼_Click: event(),
  시그니처교재만들기2단계_표지선택탭_Click: event<EventPropertiesSchema.시그니처교재만들기_2단계>(),
  시그니처교재만들기2단계_표지선택탭_다음단계_Click:
    event<EventPropertiesSchema.시그니처교재만들기_2단계>(),
  시그니처교재만들기2단계_교재정보탭_Click: event<EventPropertiesSchema.시그니처교재만들기_2단계>(),
  시그니처교재만들기2단계_교재정보탭_이전단계_Click:
    event<EventPropertiesSchema.시그니처교재만들기_2단계>(),
  시그니처교재만들기2단계_교재정보탭_교재만들기버튼_Click:
    event<EventPropertiesSchema.시그니처교재만들기_2단계>(),
  학습지휴지통_영구삭제파퍼_Click: event<EventPropertiesSchema.학습지선택개수>(),
  학습지휴지통_영구삭제완료_Click: event<EventPropertiesSchema.학습지선택개수>(),
  학습지휴지통_휴지통비우기_Click: event<EventPropertiesSchema.학습지선택개수>(),
  유형분석메뉴버튼_Click: event<EventPropertiesSchema.유형분석_공통>(),
  유형분석_학년학기드롭리스트_목록_Click: event<EventPropertiesSchema.유형분석_공통>(),
  유형분석_교재필터선택_적용하기버튼_Click: event<EventPropertiesSchema.유형분석_공통>(),
  유형분석_학교별기출필터선택_적용하기버튼_Click: event<EventPropertiesSchema.유형분석_공통>(),
  유형분석_칩_Click: event<EventPropertiesSchema.유형분석_칩>(),
  유형분석_칩_학생명_Click: event<EventPropertiesSchema.유형분석_칩>(),
  유형분석_유형별상세보기_문풀동보기_Click: event<EventPropertiesSchema.유형분석_칩>(),
  유형분석_유형별상세보기_학습지만들기_Click: event<EventPropertiesSchema.유형분석_칩>(),
  유형분석_연산필터_Click: event<EventPropertiesSchema.유형분석_연산필터>(),
  유형분석보고서만들기_Click: event<EventPropertiesSchema.유형분석_공통>(),
  유형분석_유형별상세보기_학습지만들기_바로만들기_Click:
    event<EventPropertiesSchema.유형분석_학습지만들기>(),
  매쓰플랫로그인페이지_PAYDENY고객로그인시모달_선생님을위한맞춤제안받기Click: event(),
  매쓰플랫로그인페이지_PAYDENY고객로그인시모달_닫기: event(),
  메뉴얼안내_팝업노출: event<EventPropertiesSchema.메뉴얼_팝업타입>(),
  메뉴얼안내_건너뛰기버튼_Click: event<EventPropertiesSchema.메뉴얼_팝업타입>(),
  메뉴얼안내_시작하기버튼_Click: event<EventPropertiesSchema.메뉴얼_팝업타입>(),
  메뉴얼유도_스피치버블노출: event<EventPropertiesSchema.메뉴얼_버블타입>(),
  메뉴얼유도_스피치버블_보기버튼_Click: event<EventPropertiesSchema.메뉴얼_버블타입>(),
  메뉴얼유도_스피치버블_닫기버튼_Click: event<EventPropertiesSchema.메뉴얼_버블타입>(),
  단원유형학습지만들기_메뉴얼시작: event(),
  시중교재학습지만들기_메뉴얼시작: event(),
  학교별기출학습지만들기_메뉴얼시작: event(),
  기출업로드학습지만들기_메뉴얼시작: event(),
  학습지출제프린트_메뉴얼시작: event(),
  학습지채점_메뉴얼시작: event(),
  학습지오답관리_메뉴얼시작: event(),
  시그니처교재학습지만들기_메뉴얼시작: event(),
  학부모결제_메뉴얼시작: event(),
  단원유형학습지만들기_메뉴얼종료: event(),
  시중교재학습지만들기_메뉴얼종료: event(),
  학교별기출학습지만들기_메뉴얼종료: event(),
  기출업로드학습지만들기_메뉴얼종료: event(),
  학습지출제프린트_메뉴얼종료: event(),
  학습지채점_메뉴얼종료: event(),
  학습지오답관리_메뉴얼종료: event(),
  시그니처교재학습지만들기_메뉴얼종료: event(),
  학부모결제_메뉴얼종료: event(),
  원본열람_이번달열람안내_Click: event(),
  '원본열람_60%초과안내': event<EventPropertiesSchema.열람액션구분>(),
  원본열람모달_열람: event<EventPropertiesSchema.열람액션구분>(),
  원본열람모달_불가안내: event<EventPropertiesSchema.열람액션구분>(),
  원클릭보고서만들기_Click: event(),
  원클릭보고서만들기_보고서만들기_Click: event<EventPropertiesSchema.원클릭보고서설정>(),
  원클릭보고서만들기_인쇄하기_Click: event<EventPropertiesSchema.원클릭보고서설정>(),
  원클릭보고서만들기_다운로드_Click: event<EventPropertiesSchema.원클릭보고서설정>(),
  원클릭보고서만들기_올림앱공유_Click: event<EventPropertiesSchema.원클릭보고서설정>(),
  KMM_인터뷰영상_Click: event(),
  KMM_샘플시험지보고서_Click: event(),
  KMM_홍보물다운_Click: event(),
  상장다운로드_회차_click: event(),
  상장다운로드_click: event(),
  상장배너구매하기_click: event(),
  상장배너구매하기_결제하기_click: event<EventPropertiesSchema.상장배너구매하기_탭종류>(),
  상장배너구매하기_상장주문하기_탭_click: event(),
  상장배너구매하기_상장주문하기_체크박스_click: event(),
  상장배너구매하기_상장주문하기_수량_click: event(),
  상장배너구매하기_배너주문하기_탭_click: event(),
  상장배너구매하기_배너주문하기_옵션선택_click: event(),
  상장배너구매하기_배너주문하기_추가옵션_click: event(),
  상장배너구매하기_배너주문하기_수량_click: event(),
  상장배너구매하기_수상자리스트_click: event(),
  '상장배너구매하기_물품 자세히보기_click': event(),
  상장배너구매하기_배송지수정_click: event(),
  상장배너구매하기_배송지수정_확인_click: event(),
  코칭러닝_학년반선택버튼_Click: event(),
  코칭러닝_학년반선택_학년반적용버튼_Click: event(),
  오늘의학습_오늘의학습설정하기버튼_Click: event<EventPropertiesSchema.전체학생여부>(),
  오늘의학습_오늘의학습설정하기_설정완료버튼_Click: event<EventPropertiesSchema.전체학생여부>(),
  코칭러닝_주간랭킹_학습결과바로보기버튼_Click: event<EventPropertiesSchema.코칭러닝랭킹>(),
  오늘의학습_학생앱화면_풀이화면보기버튼_Click: event<EventPropertiesSchema.전체학생여부>(),
  오늘의학습_탭_click: event<EventPropertiesSchema.전체학생여부>(),
  오늘의학습_온보딩모달_노출: event(),
  오늘의학습_온보딩모달_닫기버튼_click: event(),
  오늘의학습_온보딩모달_다시보지않기버튼_click: event(),
  오늘의학습_온보딩모달_활용하기버튼_click: event(),

  // 보고서 관련 이벤트
  보고서_Click: event(),
  보고서공유_Click: event<EventPropertiesSchema.보고서공유>(),
  보고서공유_공유방법_문자메시지_Click:
    event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  보고서공유_공유방법_올림앱_Click: event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  보고서공유_공유방법_카카오톡_Click: event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  보고서공유_공유방법_학부모앱_Click: event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  '보고서다운로드/내보내기_Click': event<EventPropertiesSchema.보고서타입>(),
  보고서리스트_지금만들어보기_Click: event(),
  보고서리스트_캘린더기간선택_적용하기_Click: event(),
  보고서만들기_Click: event<EventPropertiesSchema.보고서생성대상>(),
  보고서만들기_다음단계_Click: event<EventPropertiesSchema.보고서만들기_다음단계>(),
  보고서만들기_다음단계_보고서만들기_Click: event(),
  보고서만들기_다음단계_보고서만들기: event<EventPropertiesSchema.보고서만들기_완료>(),
  보고서만들기_다음단계_저장하기_Click: event(),
  보고서만들기_다음단계_저장하기: event<EventPropertiesSchema.보고서만들기_다음단계>(),
  보고서미리보기_Click: event<EventPropertiesSchema.보고서타입>(),
  보고서삭제_Click: event(),
  보고서선택_공유하기_Click: event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  '보고서선택_다운로드/내보내기_Click':
    event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  보고서선택_선택삭제_Click: event(),
  보고서선택_인쇄하기_Click: event(),
  '보고서선택_올림앱(비)공개_Click': event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  '보고서선택_학부모앱(비)공개_Click': event<EventPropertiesSchema.보고서공유대상_개인_또는_일괄>(),
  보고서수정_Click: event<EventPropertiesSchema.보고서타입>(),
  보고서수정_다음단계_Click: event<EventPropertiesSchema.보고서상세항목>(),
  보고서수정_다음단계_보고서만들기_Click: event<EventPropertiesSchema.보고서수정_완료>(),
  보고서수정_저장하기_Click: event<EventPropertiesSchema.보고서상세항목>(),
  보고서인쇄_Click: event<EventPropertiesSchema.보고서타입>(),
  실시간보고서보기_토글_Click: event(),
  실시간보고서설정_Click: event(),
  실시간보고서설정_저장하기_Click: event<EventPropertiesSchema.실시간보고서설정>(),

  // 강의 관련 이벤트
  강의_출제하기_Click: event(),
  강의_공유하기_Click: event<EventPropertiesSchema.디바이스>(),
  강의_공유하기_카카오톡_Click: event(),
  강의_공유하기_링크복사_Click: event(),
  문풀동재생_Click: event<EventPropertiesSchema.문풀동재생>(),

  LNB_학습지_Click: event(),
  LNB_교재_Click: event(),
  LNB_학교별기출_Click: event(),
  LNB_내신대비_Click: event(),
  LNB_수능모의고사_Click: event(),
  LNB_테스트_Click: event(),
  LNB_연산_Click: event(),
  LNB_서술형_Click: event(),
  LNB_강의_Click: event(),
  LNB_KMM수학경시대회_Click: event(),
  LNB_다른기관학습지_Click: event(),

  // 챌린지 설정
  전체학생챌린지_설정버튼_Click: event<EventPropertiesSchema.챌린지설정>(),

  // 실시간 모니터링
  개별모니터링_학생명리스트_Click: event(),
  전체모니터링_칩_Click: event(),
  학습지리스트_실시간모니터링_Click: event(),

  // 학교별기출
  학교별기출_직접등록_Click: event<EventPropertiesSchema.기출원본유무>(),
  학교별기출_미리보기_Click: event(),
  학교별기출_인쇄하기_Click: event(),
  학교별기출_다운로드_Click: event(),
  학교별기출_학교명검색: event<EventPropertiesSchema.학교별기출_학교명검색>(),
  학교별기출_필터_학교명검색: event<EventPropertiesSchema.학교별기출_학교명검색>(),
  학교별기출_최근확인한학교_Click: event(),

  // ── 나의DB 관련 이벤트 ──────────────────────────
  나의DB_문제미리보기_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_문제미리보기_수정_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_파퍼_문제수정_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_파퍼_문제삭제_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_파퍼_학습지제작_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_파퍼_문제재생성_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_문제삭제모달_삭제하기_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_문항_문제재생성_Click: event<EventPropertiesSchema.나의DB_탭종류>(),
  나의DB_문제업로드_Click: event<EventPropertiesSchema.업로드_진입점>(),
  나의DB_옵션설정_학습지제작_Click: event(),
  나의DB_자료단위의재생성_Click: event(),
  나의DB_공유범위변경_저장하기_Click: event<EventPropertiesSchema.학습지공유범위>(),
  유형수정_Click: event(),
  문제업로드1단계_닫기_Click: event(),
  문제업로드1단계_이전_Click: event(),
  문제업로드1단계_다음단계_Click: event(),
  문제업로드1단계_문제편집완료_Click: event(),
  문제업로드2단계_이전_Click: event(),
  문제업로드2단계_다음단계_Click: event(),
  문제업로드2단계_닫기_Click: event(),
  문제업로드2단계_완료하기_Click: event<EventPropertiesSchema.학습지교재만들기_2단계공통>(),
  에디터_문제편집_Click: event<EventPropertiesSchema.문제편집종류>(),
  에디터_문제재생성_Click: event(),
  이미지개선_적용하기_Click: event<EventPropertiesSchema.AI생성여부>(),
  이미지개선_다시편집하기_Click: event(),
  학습지만들기_2단계_문제편집완료_Click: event(),

  // ── 학습지 업로드 관련 이벤트 ──────────────────────
  학습지업로드_Click: event(),
  학습지업로드_자료리스트_수정_Click: event(),
  문제업로드1단계_PC파일첨부_Click: event(),

  // ── 기출업로드 관련 이벤트 ──────────────────────────
  기출업로드_최근확인한학교_Click: event(),
  기출업로드_직접등록_Click: event<EventPropertiesSchema.기출원본유무>(),
  기출업로드_기출바로가기_Click: event(),
  기출업로드_기타학습리스트_Click: event(),
  서술형문제관리_Click: event(),
  서술형묶음해제_Click: event(),

  // ── 다른 기관 학습지 공개 설정 ──────────────────────
  학습지공개설정_Click: event<EventPropertiesSchema.학습지공개설정_상태>(),
  학습지공개설정_바로가기_Click: event(),

  수업_채점하기버튼_click: event<EventPropertiesSchema.채점하기버튼>(),
  서술형_수동채점전환_Click: event<EventPropertiesSchema.서술형채점대상>(),
  서술형_학생앱채점공개_Click: event(),
  서술형_학생앱공개_저장하기_Click: event(),
  서술형_오답학습지_Click: event(),
  서술형_오답학습지_바로만들기_Click: event(),
  서술형_오답학습지_편집후만들기_Click: event(),
  서술형_서술형보고서_Click: event(),
  서술형_서술형보고서_보고서만들기_Click: event<EventPropertiesSchema.서술형보고서생성>(),
  실험실_서술형AI채점_토글_Click: event<EventPropertiesSchema.실험실토글전환방향>(),

  // ── GNB ──────────────────────────────────────────
  GNB_마이페이지버튼_Click: event(),
  GNB_수업준비_click: event(),
  GNB_수업_click: event(),
  GNB_관리_click: event(),
  GNB_아카데미_click: event(),
  GNB_과목_click: event(),
  GNB_과목_잉글리시플랫_click: event(),
  GNB_과목_사이언스플랫_click: event(),
  GNB_얼리버드배너_click: event(),
  GNB_북메뉴_click: event(),
  'T11-01_GNB_알림아이콘btn': event(),
  GNB_대시보드_click: event(),
  GNB_스쿨플랫가이드_click: event(),

  // ── 온보딩 팝업 ──────────────────────────────────────
  온보딩팝업_Click: event(),
  온보딩팝업_닫기_Click: event(),

  // ── 내정보 ──────────────────────────────────────────
  프리미엄상담_click: event(),

  // ── 연산 학습지 만들기 ──────────────────────────────
  연산학습지만들기_진입점_띠배너: event(),
})

export const eventCatalog = { ...legacyEvents, ...newEvents }

export type EventSchema = { [K in keyof typeof eventCatalog]: PropsOf<typeof eventCatalog, K> }
